import { KAPLAYCtx } from "kaplay";

function make_outdoors(k: KAPLAYCtx) {
    // 30 by 17
    let ground_tiles = [
        [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 44, 29, 33, 33, 33, 33, 33, 33, 30, 47, 22, 22, 22, 22, 22, 20, 33, 33, 33],
        [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 20, 33, 33, 33, 33, 33, 33, 35, 22, 22, 22, 22, 22, 8, 17, 33, 33, 33],
        [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 8, 17, 33, 33, 33, 33, 33, 30, 47, 22, 22, 22, 22, 22, 20, 33, 33, 33, 33],
        [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 20, 33, 33, 33, 33, 33, 30, 47, 22, 22, 22, 22, 22, 8, 17, 33, 33, 33, 33],
        [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 8, 17, 33, 33, 33, 33, 30, 47, 22, 22, 22, 22, 22, 22, 20, 33, 33, 33, 33, 33],
        [22, 22, 22, 22, 22, 22, 22, 8, 10, 10, 17, 33, 33, 33, 33, 30, 47, 22, 22, 22, 22, 22, 22, 22, 20, 33, 33, 33, 33, 33],
        [22, 22, 22, 22, 22, 22, 8, 17, 33, 33, 33, 33, 33, 33, 33, 35, 22, 22, 22, 22, 22, 22, 22, 22, 20, 33, 33, 33, 30, 45],
        [11, 22, 22, 22, 22, 37, 32, 33, 33, 33, 33, 30, 45, 45, 45, 47, 22, 22, 22, 22, 22, 22, 22, 8, 17, 33, 33, 33, 35, 22],
        [35, 22, 22, 22, 22, 22, 20, 33, 33, 33, 33, 35, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 20, 33, 33, 33, 30, 47, 22],
        [18, 11, 22, 22, 22, 22, 44, 29, 33, 33, 30, 47, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 20, 33, 33, 33, 35, 22, 22],
        [33, 35, 22, 22, 22, 22, 22, 44, 45, 45, 47, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 20, 33, 33, 30, 47, 22, 22],
        [33, 18, 11, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 20, 33, 33, 35, 22, 22, 22],
        [33, 33, 35, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 20, 33, 30, 47, 22, 22, 22],
        [33, 33, 35, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 8, 17, 33, 35, 22, 22, 22, 22],
        [33, 33, 35, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 8, 17, 33, 30, 47, 22, 22, 22, 22],
        [33, 33, 35, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 20, 33, 33, 35, 22, 22, 22, 22, 22],
        [33, 33, 18, 11, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 8, 17, 33, 33, 35, 22, 22, 22, 22, 22],
    ];
    let path = [
        [0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 4, 7, 2, 1, 4, 5, 4, 5, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    ]
    let tree_spaces = [
        [5, 4],
        [1, 1],
        [9, 2],
        [5, 0],
        [7, 3],
        [3, 6],
        [3, 9],
        [5, 11],
        [6, 14],
        [20, 2],
        [24, 0],
        [23, 4],
        [20, 5],
        [18, 7],
        [27, 17],
        [25, 15],
        [29, 12],
        [28, 14],
        [29, 9],
        [21, 9],
        [12, 16],
        [10, 17],
    ];
    for (let y = 0; y < 17; y++) {
        for (let x = 0; x < 30; x++) {
            k.add([
                k.sprite("ground", { frame: ground_tiles[y][x] }),
                k.pos(16 * x, 16 * y)
            ]);
            if (path[y][x] != 0) {
                k.add([
                    k.sprite("roads", { frame: path[y][x] - 1 }),
                    k.pos(16 * x, 16 * y),
                ]);

            }
            else if (ground_tiles[y][x] == 22 && ((y + x) % 2 == 0 || Math.random() > 0.8) && Math.random() > 0.2 && !(y > 8 && y < 13 && x > 10 && x < 22) && tree_spaces.every(v => v[0] != x || v[1] != y)) {
                k.add([
                    k.sprite("ground_decor", { frame: [0, 1, 2, 3, 4, 13, 14][Math.floor(Math.random() * 7)] }),
                    k.pos(16 * x, 16 * y)
                ])
            }
            if (ground_tiles[y][x] == 33 && Math.random() > 0.8) {
                let bubble = k.add([
                    k.sprite("bubbles", { flipX: Math.random() > 0.5 }),
                    k.pos(16 * x, 16 * y)
                ]);
                bubble.play("bubble", { speed: Math.random() * 6 + 6 });
            }
        }
    }
    for (let i = 0; i < tree_spaces.length; i++) {
        k.add([
            k.sprite(Math.random() > 0.5 ? "maple_large" : "maple_small"),
            k.pos(16 * tree_spaces[i][0] - 8, 16 * tree_spaces[i][1] - 32),
            k.animate(),
        ]);

    }
    k.add([k.sprite("house"), k.pos(16 * 11, 16 * 6 - 4)]);
    let well = k.add([k.sprite("well"), k.pos(16 * 19 + 8, 16 * 9)]);
    well.play("run");
    k.add([k.sprite("picky_kitty"), k.pos(240 - 86 / 2, 16 * 1)]);

}

export { make_outdoors };